import useInitialConfigStore from "../../../storeModules/useInitialConfigStore";
import findStep from "./findStep";
import useBotControlStore from "../../../storeModules/useBotControlStore";

const copySteps = [
  {
    name: "copy_inicial",
    sender: "bot",
    text: () => {
      const { initialCopys } = useInitialConfigStore.getState();
      const textBox = initialCopys[0].mensagem;
      return textBox;
    },
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("copy_intermediaria_2").index,
      });
    },
  },
];

export default copySteps;
